import { get, patch, post, destroy } from './httpClient'
export const getPromotions = (query) => get('/promotion', query)
export const apiCheckPromotion = (object) => post('/promotion/usevoucher', object)
export const addPromotion = (data) => post('/promotion/create', data)
export const updatePromotion = (id, data) => patch(`/promotion/update/${id}`, data)
export const checkVoucher = (voucher) => post('/promotion/checkvoucher', { voucher })
export const deletePromotion = (ids) => destroy('/promotion/delete', { promotion_id: ids })
